import { observer } from 'mobx-react';
import * as React from 'react';
import { WrappedField } from '../../../core/forms';
import { Option } from '../../../core/options';

import './default-radio.scss';

interface DefaultRadioProps<T extends string | boolean | undefined> {
    field: WrappedField<T>;
    options: Option<T>[];
    stack?: boolean;
    contrast?: boolean;
    className?: string;
    'data-role'?: string;
}

export const DefaultRadio = observer(function DefaultRadio<
    T extends string | boolean | undefined
>(props: DefaultRadioProps<T>) {
    const [randomId] = React.useState(() => Math.round(Math.random() * 100000));
    const { className, field, options, contrast, stack } = props;

    return (
        <fieldset
            className={classnames(className, 'field-radio', {
                'field-radio--contrast': contrast,
                'field-radio--vertical': stack,
                'field-radio--horizontal': !stack
            })}
        >
            {options.map((option) => {
                const optionId = `${randomId}-${option.value}`;

                const onChange = () => {
                    field.value = option.value;
                };

                return (
                    <dd key={optionId}>
                        <input
                            type="radio"
                            id={optionId}
                            checked={field.value === option.value}
                            onChange={onChange}
                            required
                            data-role={props['data-role']}
                            data-role-value={option.value}
                        />{' '}
                        <label className="field-radio-label" htmlFor={optionId}>
                            {option.label}
                        </label>
                    </dd>
                );
            })}
        </fieldset>
    );
});
